var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSeamless = function SvgSeamless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.65 8.25a3.9 3.9 0 0 0-7.696-.9h-.36a3.15 3.15 0 0 0-3.088 2.533l-.778 3.882a1.35 1.35 0 0 1-1.323 1.085h-.36a3.9 3.9 0 1 0 0 1.8h.361a3.15 3.15 0 0 0 3.086-2.533l.78-3.882a1.35 1.35 0 0 1 1.323-1.085h.36a3.9 3.9 0 0 0 7.695-.9Zm0 0h-.15.15Zm-1.96-.804a2.099 2.099 0 1 1-3.878 1.607 2.099 2.099 0 0 1 3.878-1.607ZM6.735 17.235a2.1 2.1 0 1 1-2.97-2.97 2.1 2.1 0 0 1 2.97 2.97Z",
    fill: "#376C65",
    stroke: "#376C65",
    strokeWidth: 0.3
  })));
};

export default SvgSeamless;